import { ConnectedConfigureNetworkPage } from "fleet/controller/network/connected-configure";
import { ConnectedEditNetworkPage } from "fleet/controller/network/connected-edit";
import { ConnectedNetworkFlagsPage } from "fleet/controller/network/connected-flags";
import { ConnectedNetworkListPage } from "fleet/controller/network/connected-list";
import { ConnectedNewNetworkPage } from "fleet/controller/network/connected-new";
import { ConnectedNetworkViewV2Page } from "fleet/controller/network/connected-view-v2";
import React from "react";
import { PrivateRoute } from "ui/private-route";
import { VIEW } from "view/views";

function renderNetworkRoutes() {
  return [
    <PrivateRoute
      exact
      path="/networks"
      key="network-list"
      component={ConnectedNetworkListPage}
    />,
    <PrivateRoute
      exact
      path={`/networks/${VIEW.CREATE}`}
      key="network-new"
      component={ConnectedNewNetworkPage}
    />,
    <PrivateRoute
      exact
      path="/networks/:id"
      key="network-view"
      component={ConnectedNetworkViewV2Page}
    />,
    <PrivateRoute
      exact
      path="/networks/:id/configure"
      key="network-configure"
      component={ConnectedConfigureNetworkPage}
    />,
    <PrivateRoute
      exact
      path="/networks/:id/flags"
      key="network-flags"
      component={ConnectedNetworkFlagsPage}
    />,
    <PrivateRoute
      exact
      path={`/networks/:id/${VIEW.EDIT}`}
      key="network-edit"
      component={ConnectedEditNetworkPage}
    />,
  ];
}

export { renderNetworkRoutes };
